module.exports = __webpack_public_path__ + "img/btn-reformer@1x.f62da270.png";